<script setup lang="ts">
import {useThemeStore} from "@/stores/theme";

const route = useRoute();
const isMounted = ref(false);

const themeStore: ThemeStore = useThemeStore()
const {
    isDealer
} = usePortalTerminology();

onMounted(() => {
    isMounted.value = true;
});

watch(isDealer, (newVal) => {
    if (!isMounted.value) return;
    if (newVal && !route.path.startsWith('/dealer')) {
        navigateTo('/dealer/dashboard')
        themeStore.applyTheme()
    }
})
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
        <ScrollTop />
    </NuxtLayout>
</template>

<style>
.page-enter-active,
.page-leave-active {
    transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
    opacity: 0;
    filter: blur(1rem);
}
</style>
